// src/pages/MindSparkHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MindSparkHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/mindspark");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💰" },
    { label: "Digital Learning", emoji: "💡" },
    { label: "Self Reflection & Social", emoji: "🪞" },
    { label: "Shopping", emoji: "🛍️" },
  ];

  const menuButtons1 = [
    // 💡 DIGITAL LEARNING
    { label: "My MindSpark BookShelf", emoji: "📚", link: "/bookshelf", group: "Digital Learning" },
    { label: "MindSpark Immersive Magazine", emoji: "📰", link: "/mindspark-bookworld", group: "Digital Learning" },

    // 💰 DIGITAL INCOME
    { label: "ValueShare", emoji: "💱", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "My Income", emoji: "💰", link: "/mindspark-income", group: "Digital Income" },
    { label: "Introduce User", emoji: "👥📢", link: "/sheearns-introduce", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️💻", link: "/digiboutique", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🛒🎁", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Marksheet Contest", emoji: "📜🏆", link: "/applause-marksheet-contest", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "📺💎", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Refer", emoji: "👥💸", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Resell", emoji: "🔄💰", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Become Aggregator", emoji: "🤝", link: "/digiboutique", group: "Digital Income" },
    { label: "Become Franchise", emoji: "🏪", link: "/digiboutique", group: "Digital Income" },
    { label: "MindSpark Winners", emoji: "🎉", link: "/mindsparkdb", group: "Digital Income" },
    { label: "Aalu Dalo Sona Nikalo", emoji: "🥔💰", link: "/aaludalosonanikalocomingsoon", group: "Digital Income" },

    // 🗂️ Self Reflection & Social
    { label: "Daily Management", emoji: "📝", link: "/mindspark-daily", group: "Self Reflection & Social" },
    { label: "MindSpark Ranking", emoji: "🏆", link: "/mindspark-ranking", group: "Self Reflection & Social" },
    { label: "MindSpark Tonic", emoji: "💡", link: "/tonic-knowledge", group: "Self Reflection & Social" },
    { label: "Focus Timer", emoji: "⏱️", link: "/focus-timer-home", group: "Self Reflection & Social" },
    { label: "MindSpark AI Counselling", emoji: "🧠", link: "/aicounselling-about", group: "Self Reflection & Social" },
    { label: "My Digital Card", emoji: "💳", link: "/contact-genious-home", group: "Self Reflection & Social" },
    { label: "POV", emoji: "🗣️", link: "/povify-home", group: "Self Reflection & Social" },
    { label: "Immersive Slides", emoji: "📊", link: "/visualbrief-home", group: "Self Reflection & Social" },

    // 🛍️ SHOPPING / COMMERCE ZONE
    { label: "Unity Deals", emoji: "🛍️", link: "/unitydeals", group: "Shopping" },
    { label: "ThinkXpress", emoji: "🚀", link: "/thinkxpresshome", group: "Shopping" },
    { label: "Nearby Deals", emoji: "📍🛒", link: "/nearbydeals", group: "Shopping" },
    { label: "Products", emoji: "📦", link: "/orderflow-products", group: "Shopping" },
    { label: "Services", emoji: "🛠️", link: "/think-service-home", group: "Shopping" },
    { label: "Rental", emoji: "🏠", link: "/think-rent-home", group: "Shopping" },
    { label: "Wholesale", emoji: "🏬", link: "/thinkwholesale-home", group: "Shopping" },
    { label: "Sell", emoji: "💹", link: "/orderflow-my-mlm-request-list", group: "Shopping" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-blue-100 font-sans">
      <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-blue-400">💡 MindSpark</div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
             People Self Engagement + Community Growth
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-blue-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                Welcome, {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                Login
              </Link>
              <span className="text-blue-500">|</span>
              <Link to="/signup" className="text-blue-300 hover:text-yellow-300">
                Register
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-blue-900/40 text-white text-xs sm:text-sm py-2 mt-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-2 text-m lg:text-lg">
          <a href="/mindspark-insights" className="hover:text-yellow-200">💭 About</a>
          <a href="/rim" className="hover:text-yellow-300">🌏 RIM</a>
          <a href="/mindspark-updates" className="hover:text-yellow-200">📊 Updates</a>
          <a href="/mindspark-faq" className="hover:text-yellow-200">🤔 FAQ</a>
        </div>
        <div className="text-[12px] lg:text-lg text-center my-1 mx-1 mt-2  text-blue-200/90">
           Digital Micro-Earning and Micro-Learning for Indians!
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-xs lg:text-m">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-blue-700">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-purple-700 text-yellow-200 shadow-md"
                  : "bg-blue-800 text-blue-100 hover:bg-blue-900"
              }`}
            >
              <span className="text-xl">{group.emoji}</span>
              <span className="mt-1 text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-blue-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-xs lg:text-m transition bg-transparent hover:bg-blue-700 hover:text-yellow-200 text-blue-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xl lg:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#2a0f2f] border-t border-blue-800 text-blue-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default MindSparkHome;



  //         <a href="#whyus" className="block hover:text-purple-600">About MindSpark</a>
  //         <Link to="/mindsparkupdates" className="block hover:text-purple-600">News</Link>

      // <section
      //   className="relative min-h-[60vh] sm:min-h-[70vh] bg-cover bg-center flex items-center justify-center text-white"
      //   style={{
      //     backgroundImage: "url('/assets/banners/mindspark.webp')",
      //   }}
      // >
      //   <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      //   <div className="relative z-10 px-4 sm:px-6 md:px-10 lg:px-16 py-4 w-full max-w-6xl mx-auto">
      //     <div className="flex flex-col items-center justify-center bg-gray-900/90 p-2 shadow-lg rounded-2xl ">
      //       <div className="w-full bg-gray-500 p-2 rounded-2xl shadow-lg items-center">
      //         <div className="flex items-center justify-center flex-row gap-3">
      //           <a href="/mindsparkbookshelf" className="hover:text-purple-400 transition underline">My MindSpark BookShelf</a>
      //           <a href="/rankings" className="hover:text-purple-400 transition underline">MindSpark Ranking</a>
      //           <a href="/mindsparkdb" className="hover:text-purple-400 transition underline">MindSpark Winners</a>
      //           <a href="/contact-genious-home" className="hover:text-purple-400 transition underline">My Digital Card</a>
      //         </div>
      //         <div className="flex flex-row justify-center items-center gap-2 mb-0">

      //           <button onClick={() => navigate("/mindsparkbookworld")} className="w-full h-10 px-4 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm mt-4">
      //             MindSpark Immersive Magazine of The Month
      //           </button>
      //         </div>
      //         <div className="flex justify-center flex-row gap-3">
      //           <h2 className="text-m text-yellow-200 font-semibold mb-1">Fun & Rewards:</h2>
      //           <a href="/applause-hub-home" className="hover:text-purple-400 transition underline">Marksheet Contest</a>
      //           <a href="/kharchojeeto" className="hover:text-purple-400 transition underline">Kharcho Jeeto</a>
      //           <a href="/aaludalosonanikalocomingsoon" className="hover:text-purple-400 transition underline">Aalu Dalo Sona Nikalo - A Gamified Contest!</a>
      //         </div>
      //       </div>

      //       <div className="bg-gray-900/90 p-1 shadow-lg">
      //         <div className="flex flex-row gap-3 mb-1">
      //           <h2 className="text-m text-purple-200 font-semibold mb-1">Utilities:</h2>
      //           <a href="/eduemi" className="hover:text-purple-400 transition underline">EduEMI</a>
      //           <a href="/tonic-knowledge" className="hover:text-purple-400 transition underline">Tonic</a>
      //           <a href="/focus-timer-home" className="hover:text-purple-400 transition underline">Focus Timer</a>
      //           <h3 className="text-m text-purple-200 font-medium mb-1">| Social:</h3>
      //           <a href="/povify-home" className="hover:text-purple-400 transition underline">POV</a>
      //           <a href="/visualbrief-home" className="hover:text-purple-400 transition underline">Immersive Slides</a>
      //           <h3 className="text-m text-purple-200 font-medium mb-1">| AI:</h3>
      //           <a href="/aicounselling-about" className="hover:text-purple-400 transition underline">Counselling</a>
      //           <a href="#" className="hover:text-purple-400 transition underline">Handwriting Analysis</a>
      //         </div>
      //         <div className="flex flex-row gap-3 mb-1">
      //           <h3 className="text-m text-yellow-200 font-medium mb-1">Pocket Money / Earning:</h3>
      //           <a href="/orderflow-earning-estimator" className="hover:text-purple-400 transition underline">Refer</a>
      //           <a href="/orderflow-earning-estimator" className="hover:text-purple-400 transition underline">Resell</a>
      //           <a href="/visigift-home" className="hover:text-purple-400 transition underline">Rewarding Ads</a>
      //           <a href="/OrderFlowSpotBuy" className="hover:text-purple-400 transition underline">Rewarding Videos</a>
      //           <a href="#" className="hover:text-purple-400 transition underline">Become Aggregator</a>
      //           <a href="#" className="hover:text-purple-400 transition underline">Become Franchise</a>
      //         </div>
      //       </div>

      //       <div className="bg-gray-900/90 p-1 shadow-lg">
      //         <div className="flex flex-row gap-3">
      //           <h2 className="text-m text-purple-200 font-semibold mb-1">Commerce Zone:</h2>
      //           <a href="/unitydeals" className="hover:text-purple-400 transition underline">Unity Deals</a>
      //           <a href="/thinkxpresshome" className="hover:text-purple-400 transition underline">ThinkXpress</a>
      //           <a href="/nearbydeals" className="hover:text-purple-400 transition underline">Nearby Deals</a>
      //           <a href="/orderflow-products" className="hover:text-purple-400 transition underline">Products</a>
      //           <a href="/think-service-home" className="hover:text-purple-400 transition underline">Services</a>
      //           <a href="/think-rent-home" className="hover:text-purple-400 transition underline">Rental</a>
      //           <a href="/thinkwholesale-home" className="hover:text-purple-400 transition underline">Wholesale</a>
      //           <a href="/orderflow-my-mlm-request-list" className="hover:text-purple-400 transition underline">Sell</a>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </section>

      {/* MindSpark Certificate */}
      {/* <MindSparkDB /> */}

      // <section id="whyus" className="py-4 px-6 md:px-20 bg-gradient-to-r from-purple-600 to-purple-700">
      //   <h2 className="text-xl font-bold text-center mb-2 text-white">Why Choose MindSpark?</h2>
      //   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-center text-white">
      //     {features.map((feature, idx) => (
      //       <div key={idx} className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
      //         <div className="text-xl mb-5">{feature.emoji}</div>
      //         <h4 className="text-lg font-semibold mb-3">{feature.title}</h4>
      //         <p className="text-sm">{feature.desc}</p>
      //       </div>
      //     ))}
      //   </div>
      // </section>

      // <section id="mindspark" className="py-8 px-6 md:px-20 bg-gradient-to-r from-purple-700 to-purple-800 text-white">
      //   <h2 className="text-xl font-bold text-center mb-2">MindSpark – Your Daily Growth & Reflection Buddy</h2>
      //   <div className="max-w-6xl mx-auto space-y-4">

      //     <div className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
      //       <h3 className="text-m font-semibold mb-3">✨ Core Features</h3>
      //       <ul className="list-disc list-inside text-sm space-y-1">
      //         <li><strong>📝 Chronicle</strong> — Daily logs for thoughts, moods, study habits, and personal reflections.</li>
      //         <li><strong>👏 Applause</strong> — Celebrate your wins (big or small), appreciate friends, family & peers.</li>
      //         <li><strong>🔍 Root Cause Analysis (RCA)</strong> — Learn to ask “Why?” multiple times, turn confusion into clarity, build a problem-solving mindset.</li>
      //         <li><strong>📖 Diary / Yearbook</strong> — Auto-compiled from Chronicle, Applause & RCA → downloadable memory book of your school/college years.</li>
      //       </ul>
      //     </div>

      //     <div className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
      //       <h3 className="text-m font-semibold mb-1">✨ Celebrate Wins, Stay Inspired</h3>
      //       <ul className="list-disc list-inside text-sm space-y-1">
      //         <li><strong>💳 Reader ID Card</strong> — Create & share your unique digital identity.</li>
      //         <li><strong>⚡ Brain Fuel Quizzes</strong> — Daily 3-question challenges (general knowledge, current affairs, creativity, mental health).</li>
      //         <li><strong>📰 Youth Knowledge</strong> — Daily top 10 youth-friendly updates from the world.</li>
      //         <li><strong>🏆 Leaderboard & Rewards</strong> — Track activities, earn points, win exciting prizes & badges.</li>
      //         <li><strong>🎙️ Workshops & Podcasts</strong> — Interactive talks on studies, career, relationships, creativity & self-growth.</li>
      //         <li><strong>📊 Report Card Challenge</strong> — Log your academic + personal progress, compete in friendly contests.</li>
      //         <li><strong>🎮 MindSpark Games</strong> — Quick, fun brain teasers & logic puzzles to sharpen thinking.</li>
      //       </ul>
      //     </div>

      //     <div className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
      //       <h3 className="text-m font-semibold mb-1">✨ Empowering Readers & Writers Beyond Reflection</h3>
      //       <ul className="list-disc list-inside text-sm space-y-1">
      //         <li><strong>🤖 AI Buddy Counselling</strong> — 24x7 judgment-free support for studies, friendships, stress, or career doubts.</li>
      //         <li><strong>👩‍🏫 Expert Mentoring</strong> — Pay-per-minute access to real mentors, teachers & career guides.</li>
      //         <li><strong>👛 MindSpark Wallet</strong> — Hassle-free payments & prize redemptions.</li>
      //         <li><strong>👭 Referral & Ambassador Program</strong> — Earn points/rewards by inviting friends (multi-level rewards).</li>
      //         <li><strong>🛒 Marketplace</strong> — Buy/sell products, books, art & digital creations.</li>
      //         <li><strong>🎁 MindSpark Collectibles</strong> — Earn, trade, gift or sell digital collectibles & merch.</li>
      //         <li><strong>⏱️ Focus Timer</strong> — Stay productive with Pomodoro-style focus sessions.</li>
      //         <li><strong>📝 Creator Hub (Upcoming)</strong> — Share writings, videos, art & monetize your talent.</li>
      //         <li><strong>📊 Dashboard</strong> — Visualize moods, habits, growth & progress in one place.</li>
      //         <li><strong>🌍 Nation Builder</strong> — Every learning, reflection & activity adds to your personal growth → and Bharat’s future.</li>
      //       </ul>
      //     </div>
      //   </div>
      // </section>
